<template>
    <img v-if="img" :src="spacerUrl" :width="width" :height="height" />
    <component :is="tag" v-else :class="classes" :style="styles">{{
        text
    }}</component>
</template>

<style scoped>
.inline-block {
    display: inline-block;
}

.box {
    display: block;
}

.filler {
    background: #dddddd;
    overflow: hidden;
    position: relative;
}

.with-scroller:before {
    content: " ";
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    width: 100px;
    background: linear-gradient(
        90deg,
        rgba(221, 221, 221, 1) 0%,
        rgba(246, 246, 246, 1) 50%,
        rgba(221, 221, 221, 1) 100%
    );
    animation: scroll 2s linear;
    animation-iteration-count: infinite;
}

@keyframes scroll {
    from {
        transform: translateX(-100%);
    }

    to {
        transform: translateX(100%);
    }
}
</style>

<script setup lang="ts">
import { computed, ref } from "vue";
import { spacerUrl } from "./empty-pixel";

const props = defineProps({
    min: {
        type: Number,
        default: 10,
    },
    max: {
        type: Number,
        default: 100,
    },
    box: {
        type: Boolean,
        default: false,
    },
    img: {
        type: Boolean,
        default: false,
    },
    aspectRatio: {
        type: String,
        default: "",
    },
    realLetters: Boolean,
    width: [Number, String],
    height: [Number, String],
    tag: {
        type: String,
        default: "div",
    },
    txt: Boolean,
});

const lorem =
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sagittis mattis quam in porta. Donec a.";

const text = ref(generateText());

const classes = computed(() => {
    return {
        filler: true,
        "with-scroller": !props.txt,
        box: props.box,
        "inline-block": !props.box && !props.txt,
    };
});

function pixelString(v: number | string) {
    if (typeof v === "number") return v + "px";
    if (!v.endsWith("px") && !v.endsWith("%")) return v + "px";
    return v;
}

const styles = computed(() => {
    const style: { [key: string]: string } = {};
    if (props.aspectRatio != "") {
        style["aspect-ratio"] = props.aspectRatio;
    }
    if (props.width != null) {
        style["width"] = pixelString(props.width);
    }
    if (props.height != null) {
        style["height"] = pixelString(props.height);
    }
    if (props.realLetters) {
        style["color"] = "transparent";
    }
    return style;
});

function generateText() {
    if (props.box || props.img) return "";
    const length = rand(props.min, props.max);
    if (length === 0) return "";
    if (props.realLetters) {
        return lorem.substring(0, length);
    }
    let val = "";
    for (let i = 0; i < length; i++) {
        if (i > 0 && i % 7 === 0) {
            val += " ";
        } else {
            val += "\xa0";
        }
    }
    return val;
}

function rand(min: number, max: number, round = true) {
    const width = max - min;
    let val = min + Math.random() * width;
    if (round) val = ~~val;
    return val;
}
</script>
